// extracted by mini-css-extract-plugin
export default {"pageTabsContainer":"pageTabsContainer-Ltj9d6QV","horizontal":"horizontal-mHiney3l","vertical":"vertical-hBwknS8O"};